/*
 * Provide tab functionality.
 */
var TabController = (function ($) {

	var doc;

	function ready() {
		doc = $(document.body);
        doc.on('click', '.tab-group > ul li', onTabClick);
        doc.on('focusin', '.tab-content div', onTabFocusin);
        /* 
         * This should be able to be just an additional event bound to 
         *              doc.on('click', '.tab-group > ul li', onTabClick);
         * or by binding 
         *              doc.on('focusin', '.tab-group > ul li', onTabClick);
         * but neither of those seem to work.
        */
        $('.tab-group > ul li').on('focusin', onTabClick);
    }

    function onTabClick(e) {
        e.preventDefault();
        var tab = $(e.currentTarget);
		if (!tab.hasClass('active')) {
			var tabGroup = tab.closest('.tab-group'),
					tabId = tab.attr('data-tab-id'),
					tabContent = tabGroup.find('.tab-content');
			
			tabContent.add(tab.siblings()).removeClass('active');
			tabContent.filter('[data-tab-id="' + tabId + '"]').add(tab).addClass('active');
		}
    }

    /* if content is in focus (via tabbing/screen reader), make sure the tab is active */
    function onTabFocusin(e) {
        e.preventDefault();
        var tab = $(e.currentTarget.closest('.tab-content'));
        if (!tab.hasClass('active')) {
            var tabGroup = tab.closest('.tab-group'),
                tabId = tab.attr('data-tab-id'),
                tabContent = tabGroup.find('.tab-content'),
                tabMakeActive = tabGroup.find("li[data-tab-id='" + tabId + "']");
            tabContent.add(tab.siblings()).removeClass('active');
            tabContent.filter('[data-tab-id="' + tabId + '"]').add(tab).addClass('active');
            tabMakeActive.siblings().removeClass('active');
            tabMakeActive.addClass('active');
        }
    }

	$(ready);

})(jQuery);
